export default __webpack_public_path__ + "static/media/worstVerbatim.7c00294c.png";